import React from 'react';
import { useSelector } from 'react-redux';
import PlanOverview from '../../pages/home/dchp/PlanOverview';
import QuickLinks from '../../pages/home/dchp/QuickLinks';
import Label from '../type/Label';
const DchpHome = () => {
    const memberAccounts = useSelector(
        state => state?.memberAccounts?.memberAccountsDetails
    );
    return (
        <div className='dchpHomePage'>
            <h2 className='welcomeText'><Label id='welcomeText'/>{memberAccounts?.self?.firstName && ','} {memberAccounts?.self?.firstName} {memberAccounts?.self?.lastName}</h2>
            <div className="dchpHomePageSection">
                <div className='dchp-quicklinks'><QuickLinks /></div>
                <div className='dchp-planoverview'><PlanOverview /></div>
            </div>
        </div>
    );
};

export default DchpHome;
